<template>
  <div>
    <div class="vx-row">
      <vs-card>
        <!-- <div slot="header">
          <h5>Call reason par période</h5>
        </div> -->
        <vs-row>
          <vs-col>
            <div class="flex -mx-2">
              <div class="w-2/4 px-2">
                <span class="vs-select--label">Période</span>
                <date-range-picker
                  ref="picker"
                  :opens="opens"
                  :locale-data="locale"
                  :singleDatePicker="false"
                  :timePicker="false"
                  :showWeekNumbers="showWeekNumbers"
                  :showDropdowns="showDropdowns"
                  :autoApply="autoApply"
                  v-model="dateRange"
                  :ranges="false"
                  @update="updateValues"
                  :linkedCalendars="linkedCalendars"
                  :dateFormat="dateFormat"
                  :always-show-calendars="false"
                  :alwaysShowCalendars="alwaysShowCalendars"
                  class="vs-inputx vs-input--input"
                >
                  <div
                    slot="input"
                    slot-scope="picker"
                    style="min-width: 350px"
                  >
                    {{ picker.startDate | date }} - {{ picker.endDate | date }}
                  </div>
                </date-range-picker>
              </div>
              <div class="w-1/8 px-2">
                <vs-button
                  :disabled="
                    dateRange.startDate === '' && dateRange.endDate === ''
                  "
                  @click="makeSearch()"
                  style="margin-top: 18px"
                  color="primary"
                  type="filled"
                  icon="search"
                  >Recherche
                </vs-button>
              </div>
            </div>
          </vs-col>
        </vs-row>
      </vs-card>
    </div>

    <div class="vx-row">
      <vs-card>
        <!-- <vs-list v-for="(item, index) in stats" :key="index">
          <vs-list-header :title="item.name"></vs-list-header>
          <div class="vx-row">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/4 mb-base" v-for="(sub_type, key) in item.sub_types" :key="key">
              <vx-card class="overflow-hidden">
                <div slot="no-body">
                  <div class="p-6 flex justify-between flex-row-reverse items-center">
                    <small class="flex cursor-pointer"></small>
                    <div class="truncated">
                      <h2 class="mb-1 font-bold"> {{ sub_type.nb }} </h2>
                      <span>{{ sub_type.name }}</span>
                    </div>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
        </vs-list> -->
        <vs-collapse v-for="(item, index) in stats" :key="index">
          <vs-collapse-item>
            <div slot="header" class="font-bold">{{ item.name }}</div>
            <div class="vx-row" v-if="item.sub_types.length > 0">
              <div
                class="
                  vx-col
                  w-full
                  sm:w-1/2
                  md:w-1/2
                  lg:w-1/3
                  xl:w-1/4
                  mb-base
                  mt-2
                "
                v-for="(sub_type, key) in item.sub_types"
                :key="key"
              >
                <div
                  style="cursor: pointer"
                  @click="exportDetails(sub_type.requests_type_id, sub_type)"
                >
                  <vx-card class="overflow-hidden">
                    <div slot="no-body">
                      <div
                        class="
                          p-6
                          flex
                          justify-between
                          flex-row-reverse
                          items-center
                        "
                      >
                        <small class="flex cursor-pointer"></small>
                        <div class="truncated">
                          <h2 class="mb-1 font-bold">{{ sub_type.nb }}</h2>
                          <span>{{ sub_type.name }}</span>
                        </div>
                      </div>
                    </div>
                  </vx-card>
                </div>
              </div>
            </div>
            <div v-else>
              <small>Aucune requête dans la période sélectionnée</small>
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </vs-card>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";

export default {
  name: "callReason",
  components: { DateRangePicker },
  data: () => ({
    stats: [],
    opens: "center",
    showWeekNumbers: true,
    linkedCalendars: true,
    alwaysShowCalendars: true,
    showDropdowns: true,
    autoApply: false,
    locale: {
      direction: "ltr",
      format: "dd/mm/yyyy",
      separator: " - ",
      applyLabel: "Appliquer",
      cancelLabel: "Annuler",
      weekLabel: "W",
      customRangeLabel: "Custom Range",
      daysOfWeek: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      monthNames: [
        "Jan",
        "Fev",
        "Mar",
        "Avr",
        "Mai",
        "Jui",
        "Juil",
        "Aou",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      firstDay: 0,
    },
    dateRange: {
      startDate: "",
      endDate: "",
    },
    dateFormat(classes, date) {
      let yesterday = moment().subtract(1, "day");
      if (!classes.disabled) {
      }
      return classes;
    },
  }),
  mounted() {
    this.dateRange.startDate = moment(new Date()).format("YYYY-MM-DD");
    this.dateRange.endDate = moment(new Date()).format("YYYY-MM-DD");
    this.makeSearch();
  },
  methods: {
    updateValues(values) {
      this.dateRange.startDate = moment(values.startDate).format("YYYY-MM-DD");
      this.dateRange.endDate = moment(values.endDate).format("YYYY-MM-DD");
    },

    makeSearch() {
      this.$vs.loading();
      this.$http
        .post("/ebu/call-reason-period?export=0", {
          date_debut: this.dateRange.startDate,
          date_fin: this.dateRange.endDate,
        })
        .then((response) => {
          this.stats = response.data;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          } else {
            console.log(error);
          }
        });
    },
    exportDetails(type, subtype) {
      this.$vs.loading();
      let params = {
        date_debut: this.dateRange.startDate,
        date_fin: this.dateRange.endDate,
        export: "1",
        subtype: subtype.requests_subtype_id,
        type: type,
      };
      this.$http
        .post("/ebu/call-reason-period", params, {
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = link.href = url;
          link.setAttribute("download", "stats_" + subtype.name + ".xlsx");
          document.body.appendChild(link);
          link.click();
          this.customer = "";
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "login" });
          }
        });
    },
  },
};
</script>

<style>
</style>
